import * as ReactService from "@intech/react-service";
import { FuncionarioDados, FuncionarioEntidade, PesquisaDadosEntidade } from "../entidades";

class Funcionario extends ReactService.BaseService {
  constructor() {
    super("Funcionario");
  }

  Buscar = () =>
    this.CreateRequest<FuncionarioDados>(ReactService.RequestType.GET, `Buscar`);

  Pesquisar = (dados: PesquisaDadosEntidade) =>
    this.CreateRequest<FuncionarioEntidade[]>(ReactService.RequestType.POST, `Pesquisar`, dados);

}

export const FuncionarioService = new Funcionario();
